import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import Button from '@/app/components/Button';
import Icon from '@/app/components/Icon';
import { aboutSingerData } from '../footerMenuList';
import TextSmall from '../../Typography/TextSmall';
import TextSpan from '../../Typography/TextSpan';
import ButtonLabel from '../../Typography/ButtonLabel';

function FooterAboutSinger() {
  const router = useRouter();

  return (
    <div className="min-w-[191px] max-w-[12%]">
      {aboutSingerData?.map((item, index) => (
        <React.Fragment key={item?.id ?? index}>
          <TextSmall
            text={item?.title}
            className="text-white text-sm lg:text-sm font-bold mb-[8px]"
          />

          <ul className="space-y-2">
            {item?.menu?.map((menuItem) => (
              <li key={menuItem?.id}>
                <Link
                  prefetch={false}
                  aria-label="Go to about singer menu item"
                  href={menuItem?.url}
                >
                  <TextSpan
                    text={menuItem?.name}
                    className="text-white text-sm lg:text-sm font-medium hover:underline"
                  />
                </Link>
              </li>
            ))}
            <li>
              <Button
                type="outline"
                className="!h-[36px] gap-[4px] hover:bg-white/15 mt-12 py-8"
                onClick={() => router.push('/store-locator')}
              >
                <Icon type="location" />
                <ButtonLabel
                  label="Store Locator"
                  className="text-white text-base lg:text-base font-medium whitespace-nowrap"
                />
              </Button>
            </li>
          </ul>
        </React.Fragment>
      ))}
    </div>
  );
}

export default FooterAboutSinger;
